import PropTypes from "prop-types"
import { connect } from "react-redux"

import { mapShapecodeToName } from "areas/product/store/helpers/diamond"
import { StoneTable } from "areas/product/wizard-options/components"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

import SampleCertLink from "./sample-cert-link"

const InternalFinalDiamond = ({
  step,
  stone,
  selectedShape,
  selectedStoneType,
  selectedStoneTypeDescription,
}) => {
  if (!stone) return null
  return (
    <div className="mb-24 text-center">
      <p className="text-18">Your Stone:</p>
      <div className="mb-16 text-center">
        <Image
          alt=""
          height="56px"
          src={`${sl.config.jewlr_asset_url}images/product/diamond/${selectedShape}/${selectedShape}_front.png`}
          srcSet={`${`${sl.config.jewlr_asset_url}images/product/diamond/${selectedShape}/${selectedStoneType}.png`} 1x, ${`${sl.config.jewlr_asset_url}images/product/diamond/${selectedShape}/${selectedStoneType}_2x.png`} 2x`}
          width="56px"
        />
        <p>{stone.price && to_currency(stone.price)}</p>
      </div>
      {stone.is_diamond ? (
        <StoneTable>
          <tbody>
            <tr>
              <td className="font-bold">
                Carat:{" "}
                <span
                  className="font-medium"
                  data-cy="diamon-selector-custom-final-diamond-carat"
                >
                  {stone.carat}
                </span>
              </td>
              <td className="font-bold">
                Clarity:{" "}
                <span
                  className="font-medium"
                  data-cy="diamon-selector-custom-final-diamond-clarity"
                >
                  {stone.clarity}
                </span>
              </td>
            </tr>
            <tr>
              <td className="font-bold">
                Cut:{" "}
                <span
                  className="font-medium"
                  data-cy="diamon-selector-custom-final-diamond-cut"
                >
                  {stone.cut}
                </span>
              </td>
              <td className="font-bold">
                Shape:{" "}
                <span
                  className="font-medium"
                  data-cy="diamon-selector-custom-final-diamond-shape"
                >
                  {mapShapecodeToName[stone.shape]}
                </span>
              </td>
            </tr>
            <tr>
              <td className="font-bold">
                {jewlr_t("terms.Color")}:{" "}
                <span
                  className="font-medium"
                  data-cy="diamon-selector-custom-final-diamond-color"
                >
                  {stone.color}
                </span>
              </td>
              <td className="font-bold">
                Size:{" "}
                <span
                  className="font-medium"
                  data-cy="diamon-selector-custom-final-diamond-size"
                >
                  ≈ {stone.stone_size}
                </span>
              </td>
            </tr>
          </tbody>
        </StoneTable>
      ) : (
        <div className="text-center">
          <p>
            <strong>Shape: </strong>
            {mapShapecodeToName[stone.shape]}
          </p>
          <p>
            <strong>Size: </strong>≈ {stone.stone_size}
          </p>
        </div>
      )}

      {stone.is_diamond && (
        <>
          <p className="my-16 font-light">
            All our diamonds are certified by
            <br /> GIA, IGI or GSL
          </p>
          <SampleCertLink stoneType={selectedStoneType} />
        </>
      )}
      {step === "confirm_gemstone" && (
        <p className="text-15 my-24">{selectedStoneTypeDescription}</p>
      )}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const selectedStoneType = state.choices.d_stone_type.value
  let selectedStoneTypeDescription = ""
  if (ownProps.step === "confirm_gemstone") {
    selectedStoneTypeDescription = state.diamondSelector["d_stone_type"]?.find(
      (opt) => opt.value === selectedStoneType
    )?.description
  }
  return {
    selectedShape: state.choices.d_shape.value.toLowerCase(),
    selectedStoneType,
    selectedStoneTypeDescription,
    stone: state.diamondSelector.selected_diamond,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalFinalDiamond.propTypes = {
  selectedShape: PropTypes.string,
  selectedStoneType: PropTypes.string,
  selectedStoneTypeDescription: PropTypes.string,
  step: PropTypes.string,
  stone: PropTypes.object,
}

const FinalDiamond = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalFinalDiamond)

export default FinalDiamond
